// @flow

// flow hack due to: https://github.com/facebook/flow/issues/2377
type TOPIC_ACTION_TYPE = {
  TOPIC_FOLLOW: 'TOPIC_FOLLOW',
};

const topicActionTypes: TOPIC_ACTION_TYPE = {
  TOPIC_FOLLOW: 'TOPIC_FOLLOW',
};

export default topicActionTypes;
